var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 144,
    viewBox: "0 0 123 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_396_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.307 116.657C90.1109 116.657 114.272 92.5575 114.272 62.8287C114.272 33.0999 90.1109 9 60.307 9C30.5032 9 6.34241 33.0999 6.34241 62.8287C6.34241 92.5575 30.5032 116.657 60.307 116.657Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25961 31.2891C8.68534 30.8269 9.46546 29.2992 9.00206 27.8771C8.53866 26.455 7.00722 25.6768 5.5815 26.139C4.15577 26.6013 3.37565 28.1289 3.83905 29.5511C4.30245 30.9732 5.83389 31.7514 7.25961 31.2891Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1852 22.4546C14.1547 22.1403 14.6852 21.1015 14.37 20.1345C14.0549 19.1674 13.0136 18.6383 12.0441 18.9526C11.0746 19.2669 10.5441 20.3057 10.8592 21.2727C11.1743 22.2398 12.2157 22.7689 13.1852 22.4546Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.954 49.3193C121.636 47.7859 121.754 45.1825 120.217 43.5046C118.679 41.8266 116.069 41.7094 114.387 43.2428C112.705 44.7762 112.588 47.3795 114.125 49.0574C115.662 50.7354 118.272 50.8527 119.954 49.3193Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.339 30.9479C121.047 30.3022 121.097 29.2061 120.45 28.4996C119.802 27.7931 118.704 27.7437 117.995 28.3894C117.287 29.035 117.237 30.1311 117.885 30.8377C118.532 31.5442 119.631 31.5935 120.339 30.9479Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0705 15.7149C99.03 15.7149 99.8078 14.9391 99.8078 13.982C99.8078 13.025 99.03 12.2491 98.0705 12.2491C97.1111 12.2491 96.3333 13.025 96.3333 13.982C96.3333 14.9391 97.1111 15.7149 98.0705 15.7149Z",
    fill: "url(#paint0_linear_396_163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9886 90.2305C11.9481 90.2305 12.7259 89.4546 12.7259 88.4976C12.7259 87.5405 11.9481 86.7646 10.9886 86.7646C10.0292 86.7646 9.25134 87.5405 9.25134 88.4976C9.25134 89.4546 10.0292 90.2305 10.9886 90.2305Z",
    fill: "url(#paint1_linear_396_163)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_396_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1562 35.9684L100.025 106.585C100.025 108.968 98.0704 110.917 95.6817 110.917H26.7329C24.3441 110.917 22.3896 108.968 22.3896 106.585V15.8233C22.3896 13.4405 24.3441 11.491 26.7329 11.491H76.68L99.1562 35.9684Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.2124 79.7247H45.9517C45.4088 79.7247 44.9745 79.1831 44.9745 78.5333C44.9745 77.8835 45.4088 77.3419 45.9517 77.3419H87.2124C87.7553 77.3419 88.1896 77.8835 88.1896 78.5333C88.1896 79.1831 87.7553 79.7247 87.2124 79.7247Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8483 79.7247H33.5734C33.0305 79.7247 32.5962 79.1831 32.5962 78.5333C32.5962 77.8835 33.0305 77.3419 33.5734 77.3419H40.8483C41.3912 77.3419 41.8256 77.8835 41.8256 78.5333C41.8256 79.1831 41.3912 79.7247 40.8483 79.7247Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1037 71.06H68.6449C68.102 71.06 67.6677 70.5185 67.6677 69.8686C67.6677 69.2188 68.102 68.6772 68.6449 68.6772H87.1037C87.6466 68.6772 88.0809 69.2188 88.0809 69.8686C88.0809 70.5185 87.6466 71.06 87.1037 71.06Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8271 71.06H33.8991C33.3562 71.06 32.9219 70.5185 32.9219 69.8686C32.9219 69.2188 33.3562 68.6772 33.8991 68.6772H60.8271C61.37 68.6772 61.8044 69.2188 61.8044 69.8686C61.9129 70.5185 61.37 71.06 60.8271 71.06Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4803 44.958H87.8638C88.4067 44.958 88.841 44.4164 88.841 43.7666C88.841 43.1167 88.4067 42.5752 87.8638 42.5752H80.4803C79.9374 42.5752 79.5031 43.1167 79.5031 43.7666C79.5031 44.5247 79.9374 44.958 80.4803 44.958Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4294 62.2872H80.2631C79.7202 62.2872 79.2859 61.7456 79.2859 61.0958C79.2859 60.446 79.7202 59.9044 80.2631 59.9044H87.4294C87.9723 59.9044 88.4067 60.446 88.4067 61.0958C88.4067 61.7456 87.9723 62.2872 87.4294 62.2872Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6396 62.2872H54.4208C53.8779 62.2872 53.4436 61.7456 53.4436 61.0958C53.4436 60.446 53.8779 59.9044 54.4208 59.9044H73.7482C74.2911 59.9044 74.7254 60.446 74.7254 61.0958C74.7254 61.7456 74.2911 62.2872 73.6396 62.2872Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.941 96.8372H53.4437C52.9008 96.8372 52.4664 96.2957 52.4664 95.6458C52.4664 94.996 52.9008 94.4545 53.4437 94.4545H55.941C56.4839 94.4545 56.9182 94.996 56.9182 95.6458C56.9182 96.404 56.4839 96.8372 55.941 96.8372Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9918 96.8372H34.3334C33.7905 96.8372 33.3562 96.2957 33.3562 95.6458C33.3562 94.996 33.7905 94.4545 34.3334 94.4545H48.9918C49.5347 94.4545 49.9691 94.996 49.9691 95.6458C49.9691 96.404 49.5347 96.8372 48.9918 96.8372Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7553 53.6226H73.314C72.7711 53.6226 72.3368 53.0811 72.3368 52.4312C72.3368 51.7814 72.7711 51.2399 73.314 51.2399H87.8638C88.4067 51.2399 88.8411 51.7814 88.8411 52.4312C88.8411 53.0811 88.4067 53.6226 87.7553 53.6226Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3123 44.958H73.8568C74.3997 44.958 74.8341 44.4164 74.8341 43.7666C74.8341 43.1167 74.3997 42.5752 73.8568 42.5752H54.3123C53.7694 42.5752 53.3351 43.1167 53.3351 43.7666C53.3351 44.5247 53.7694 44.958 54.3123 44.958Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2335 53.6226H54.2038C53.6609 53.6226 53.2266 53.0811 53.2266 52.4312C53.2266 51.7814 53.6609 51.2399 54.2038 51.2399H67.2335C67.7764 51.2399 68.2107 51.7814 68.2107 52.4312C68.3193 53.0811 67.885 53.6226 67.2335 53.6226Z",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9936 26.3292H34.985C34.225 26.3292 33.5735 25.6793 33.5735 24.9212C33.5735 24.163 34.225 23.5132 34.985 23.5132H67.9936C68.7537 23.5132 69.4051 24.163 69.4051 24.9212C69.4051 25.6793 68.7537 26.3292 67.9936 26.3292Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.689 34.2357H34.985C34.225 34.2357 33.5735 33.5858 33.5735 32.8277C33.5735 32.0695 34.225 31.4197 34.985 31.4197H47.5804C48.3405 31.4197 48.992 32.0695 48.992 32.8277C48.992 33.5858 48.3405 34.2357 47.689 34.2357Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.68 11.491V30.9863C76.68 33.694 79.0688 35.9684 81.7833 35.9684H99.1562",
    fill: "#EAEFF4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_396_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.487 105.296C107.315 115.91 96.7827 122.842 86.1418 120.567C75.5008 118.401 68.5516 107.896 70.8318 97.2814C73.112 86.6673 83.5357 79.7355 94.1766 82.01C97.977 82.7681 101.451 84.6094 104.166 87.4254C108.835 92.0826 110.79 98.7976 109.487 105.296Z",
    fill: "url(#paint2_linear_396_163)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.517 100.845C107.517 101.603 107.517 102.361 107.408 103.119C107.3 103.661 107.3 104.31 107.083 104.852C105.78 111.892 100.133 117.091 93.51 118.174C92.207 118.39 90.9041 118.499 89.6011 118.39L82.5433 111.35L88.841 102.253L95.573 97.1621L100.351 93.6963L107.517 100.845Z",
    fill: "url(#paint3_linear_396_163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9163 93.4797C96.8761 92.6133 93.7272 92.7216 90.7955 93.8047C90.5784 93.913 90.3612 94.0213 90.2526 94.2379C89.7097 94.7794 89.2754 95.321 88.8411 95.9708C88.8411 95.6459 88.8411 95.321 88.8411 94.996C88.8411 94.8877 88.7325 94.8877 88.7325 94.8877C88.7325 94.8877 88.7325 94.8877 88.6239 94.8877C87.5381 95.4293 86.6695 96.1874 85.8008 97.0539C85.5837 97.2705 85.4751 97.4871 85.4751 97.7037C85.2579 98.2453 85.1493 98.7868 85.0408 99.22C84.9322 99.0034 84.9322 98.7868 84.8236 98.5702C84.8236 98.4619 84.715 98.4619 84.715 98.4619C84.715 98.4619 84.715 98.4619 84.6064 98.4619C83.5206 100.195 82.7606 102.144 82.5434 104.202C82.5434 104.635 82.5434 105.177 82.5434 105.61L82.652 106.368C82.652 106.477 82.652 106.477 82.7606 106.477C82.8691 106.477 82.8691 106.477 82.8691 106.368C85.4751 101.494 88.6239 97.2705 94.2701 95.2127C94.5959 95.1043 94.9216 95.2127 95.0302 95.5376C95.1388 95.8625 95.0302 96.1874 94.7044 96.2957C88.081 98.6785 85.0408 104.419 82.3262 110.376C82.2177 110.701 82.3262 111.026 82.652 111.134C82.9777 111.242 83.3035 111.134 83.412 110.809C83.8464 109.834 84.2807 108.859 84.715 107.993C84.9322 107.56 85.3665 107.126 85.9094 107.018C89.8183 106.26 93.2929 104.202 95.6817 100.953C96.0074 100.52 96.3332 100.086 96.6589 99.5449C96.7675 99.4366 96.6589 99.22 96.5503 99.22C96.5503 99.22 96.5503 99.22 96.4417 99.22L94.3787 98.7868C96.5503 98.137 97.0932 98.4619 97.9619 97.0539C98.6134 95.9708 99.3734 94.8877 100.025 93.913C100.459 93.6964 100.459 93.588 99.9163 93.4797Z",
    fill: "url(#paint4_linear_396_163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7976 62.3955C47.5804 62.3955 47.3633 62.2872 47.2547 61.9623L46.0603 58.3881H37.8082L36.6138 61.9623C36.5052 62.1789 36.288 62.3955 36.0709 62.3955H33.8992C33.7907 62.3955 33.6821 62.2873 33.5735 62.2873C33.4649 62.179 33.4649 62.0706 33.5735 61.9623L39.8712 44.8498C39.9798 44.4166 40.4141 44.2 40.7398 44.2H43.4543C43.8887 44.2 44.2144 44.4166 44.323 44.8498L50.6207 62.2873L50.5121 62.3955H47.7976ZM38.7854 55.7888H45.0831L41.9342 46.5827L38.7854 55.7888Z",
    fill: "url(#paint5_linear_396_163)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_396_163",
    x: 0.389603,
    y: 0.490967,
    width: 121.635,
    height: 143.426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_396_163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_396_163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_396_163",
    x: 62.3982,
    y: 78.5775,
    width: 55.4841,
    height: 55.4221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_396_163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_396_163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_163",
    x1: 96.4213,
    y1: 13.9572,
    x2: 99.792,
    y2: 13.9572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_396_163",
    x1: 9.33756,
    y1: 88.4879,
    x2: 12.7082,
    y2: 88.4879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_396_163",
    x1: 70.3151,
    y1: 101.291,
    x2: 109.872,
    y2: 101.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_396_163",
    x1: 90.1942,
    y1: 101.286,
    x2: 98.308,
    y2: 109.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_396_163",
    x1: 92.2956,
    y1: 103.795,
    x2: 86.2058,
    y2: 95.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_396_163",
    x1: 33.4353,
    y1: 53.323,
    x2: 50.5989,
    y2: 53.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_396_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 144,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.35cbfa9474686c0b3db52f7e563271d8.svg";
export { ForwardRef as ReactComponent };